// extracted by mini-css-extract-plugin
module.exports = {"pintxo-popup":"Popup_pintxo-popup__2yHER"};